import { MainLayout } from 'layout//MainLayout/MainLayout';

export default MainLayout;
